/**
 * Validates and extracts checklist ID from route params
 * @param idParam - The ID parameter from route params
 * @returns Valid checklist ID or null
 */
export function validateChecklistId(idParam: unknown): string | null {
  return idParam &&
    typeof idParam === "string" &&
    idParam.trim() !== "" &&
    idParam !== "undefined"
    ? idParam
    : null;
}
